// Bootstrap
require('./bootstrap');

// Vendor
require('bootstrap-datepicker');
require('jquery-ui-bundle');
require('select2');
require('bootstrap-validator');
require('jquery-serializejson');
//require('bootstrap-treeview/dist/bootstrap-treeview.min.js');
window.Highcharts = require('highcharts');
window.Resumable = require('resumablejs');
require('./resumable-custom');
require('./strength-meter');

window.Swal = require('sweetalert2');
require('block-ui');

// Custom
require('./steps');

//paso4
require('./scripts-paso-4/scriptJurisdiccionLineaAccion');
